import React, { useEffect, useState } from "react";
import QrThemeService from "../../../Services/QRCodeServices/QrThemeService/QrThemeService";
import BreadCrumb from "../../../Components/Common/BreadCrumb";
import { useParams } from "react-router-dom";
import { Card, CardBody, Col, Row } from "reactstrap";

const ThemeDetail = () => {
  const [data, setData] = useState({});
  const { id } = useParams(); // id is a string from URL parameters

  useEffect(() => {
    (async () => {
      try {
        const response = await QrThemeService.detail(id);
        console.log("🚀 ~ response:", response);
        setData(response);
      } catch (error) {
        console.log("🚀 ~ error:", error);
      }
    })();
  }, [id]);
  return (
    <div>
      <div className="page-content">
        <div className="container-fluid">
          <BreadCrumb
            pageTitle="Themes"
            title="Theme Detail"
            breadcrumbItems={[{ title: "Back To List ", link: "/theme" }]}
          />
        </div>
        <Card className="p-3">
          <CardBody>
            <Row>
              <Col className="mb-2">
                <img
                  src={`data:image/jpeg;base64,${data?.image}`}
                  className=""
                  alt="image"
                />
              </Col>

              <Col>
                <Row>
                  <Col>
                    <h5>
                      Title: <span>{data?.title}</span>
                    </h5>
                  </Col>
                  <Col md={12}>
                    <h6>
                      Default:{" "}
                      <span
                        className={`badge ${
                          data?.isDefault ? "bg-success" : "bg-danger"
                        }`}
                      >
                        {data?.isDefault ? "Yes" : "No"}
                      </span>
                    </h6>
                    <h6>
                      Active:{" "}
                      <span
                        className={`badge ${
                          data?.isActive ? "bg-success" : "bg-danger"
                        }`}
                      >
                        {data?.isActive ? "Active" : "Inactive"}
                      </span>
                    </h6>
                  </Col>
                  <Col>
                    <h5>Description:</h5>
                    <p>{data?.description}</p>
                  </Col>
                </Row>
              </Col>
            </Row>
          </CardBody>
        </Card>
      </div>
    </div>
  );
};

export default ThemeDetail;
